import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import { PaymentTabsEnum } from '../../enums/payment-tabs-enum';
import { getIsChina } from '../../../../../domain/hidden-data-provider';
import CreditCardIcon from '../../../../../ui/svg/shopping-cart/credit-card';
import PaypalIcon from '../../../../../ui/svg/shopping-cart/paypal';
import AlipayIcon from '../../../../../ui/svg/shopping-cart/alipay';
import { sendGAEvent } from '../../../../../domain/marketing/gtm-provider';
import { checkIsSubscription, SELECTED_PAYMENT_TAB_STORAGE_KEY } from '../../domain/shopping-cart-provider';
import { saveToStorage } from '../../../../../DAL/storage-provider';

const selectedStyles = {
    backgroundColor: '#ecf5ff',
    borderRadius: '4.1px',
    border: 'solid 0.7px #3452ff',
    color: '#3452ff',
};

const PaymentTabs = () => {

    const dispatch = useAppDispatch();
    const selectedPaymentTab = useAppSelector(store => store.root.selectedPaymentTab);
    const isChina = getIsChina();

    const cartData = useAppSelector(store => store.root.cartData);
    const isSubscription = checkIsSubscription(cartData);

    let isCreditCardSelected = selectedPaymentTab === PaymentTabsEnum.CreditCard;
    const isPayPalSelected = selectedPaymentTab === PaymentTabsEnum.PayPal;
    const isAliPaySelected = selectedPaymentTab === PaymentTabsEnum.AliPay;

    if((isSubscription && isAliPaySelected) || (isChina && isPayPalSelected)){
        isCreditCardSelected = true;
    }

    /**
     * change payment tab
     */
    const selectTab = (tab: PaymentTabsEnum) => {
        dispatch(
            rootActions.main({
                selectedPaymentTab: tab,
            })
        );

        // send event to google analytics -------------------
        let paymentMethod = '';
        switch (tab){
            case PaymentTabsEnum.CreditCard: {
                paymentMethod = 'Credit Card';
                break;
            }
            case PaymentTabsEnum.PayPal: {
                paymentMethod = 'PayPal';
                break;
            }
            case PaymentTabsEnum.AliPay: {
                paymentMethod = 'AliPay';
                break;
            }
        }

        saveToStorage('session-storage', SELECTED_PAYMENT_TAB_STORAGE_KEY, tab);
        sendGAEvent('Payment Method', paymentMethod);
    };

    const getPaymentRootClasses = () => {

        if(isChina){
            return isSubscription ? 'grid w-1/2' : 'grid grid-cols-2';
        }
        else{
            return isSubscription ? 'grid grid-cols-2' : 'grid grid-cols-3';
        }
    };

    return (
        <div className="mb-8">
            <div className="text-gray-500 mb-2">Pay With</div>

            <div className={`border rounded overflow-hidden font-bold text-center text-gray-700 text-tiny pointer ${ getPaymentRootClasses() }`}>
                <button
                    type="button"
                    className={`px-1 py-8 flex flex-col items-center justify-center text-center ${ isAliPaySelected && !isChina ? 'border-r' : '' }`}
                    style={ isCreditCardSelected ? selectedStyles : undefined }
                    onClick={ () => {
                        selectTab(PaymentTabsEnum.CreditCard);
                    }}>
                    <div className="mb-2"><CreditCardIcon width="25px" color={ isCreditCardSelected ? '#3452ff' : '#1d1d1d' } /></div>
                    {  !isSubscription && <div>Credit / Debit Card</div> }
                    {  isSubscription && <div>Credit Card</div> }
                </button>

                {
                    !isChina &&
                    <button
                        type="button"
                        className={`px-1 py-8 flex flex-col items-center justify-center text-center ${ isCreditCardSelected && !isChina ? 'border-r' : '' }`}
                        style={ isPayPalSelected ? selectedStyles : undefined }
                        onClick={ () => {
                            selectTab(PaymentTabsEnum.PayPal);
                        }}>
                        <div className="mb-2"><PaypalIcon width="20px" color={ isPayPalSelected ? '#3452ff' : '#1d1d1d' } /></div>
                        <span>PayPal</span>
                    </button>
                }

                {
                    !isSubscription &&
                    <button
                        type="button"
                        className={`px-1 py-8 flex flex-col items-center justify-center text-center`}
                        style={ isAliPaySelected ? selectedStyles : undefined }
                        onClick={ () => {
                            selectTab(PaymentTabsEnum.AliPay);
                        }}>
                        <div className="mb-2"><AlipayIcon width="23px" color={ isAliPaySelected ? '#3452ff' : '#1d1d1d' } /></div>
                        <div>AliPay</div>
                    </button>
                }
            </div>
        </div>
    )
};

export default PaymentTabs;
